import angular from 'angular';
import _ from 'lodash';
import Logger from '../../shared/logger';

const defaultMaxItems = 8;

export const LocationService = function ($http, Restangular) {
    const locationService = this;

    locationService.locations = {};
    locationService.url = 'https://maps.googleapis.com/maps/api/geocode/json?address=';
    locationService.key = 'AIzaSyABeSWGqtC8d7AvWQY1dzmMqEumss9KZbY';

    const getLognitudeLatitude = function (country, city, street) {
        const address = `${locationService.url + street}+${city}+${country}&key=${locationService.key}`;
        return $http.get(address);
    };

    const getLocations = function () {
        return $http.get('../resources/locations.json');
    };

    const getLocationSuggestions = function ({
        value,
        maxItems = defaultMaxItems,
    }) {
        return Restangular.all('metadata')
            .all('semiDynamicLookups')
            .post({
                currentField: {
                    field: 'locations',
                    value,
                    type: 'Text',
                    matchType: 'contains',
                },
                maxItems,
            })
            .catch(error => Logger.error(error));
    };

    const getLocationObjectFromDbLocationItem = ({ locationItem, countriesList } = {}) => {
        const locationValue = _.get(locationItem, 'value', '');

        const isNationWideLocation = !_.isString(locationValue);

        const [
            latitude = '',
            longitude = '',
        ] = isNationWideLocation ? [] : locationValue.split(',');

        const countriesNameList = _.map(countriesList, 'Name');

        const locationTextArr = _.get(locationItem, 'text', '')
            .split(',')
            .map(item => item.trim());

        let { city = '', state = '', country = '' } = {};
        if (locationTextArr && locationTextArr.length === 3) {
            [city, state, country] = locationTextArr;
        } else if (locationTextArr && locationTextArr.length === 2) {
            if (countriesNameList && countriesNameList.includes(locationTextArr[1])) {
                [city, country] = locationTextArr;
            } else {
                [city, state] = locationTextArr;
            }
        } else if (locationTextArr && locationTextArr.length === 1) {
            if (countriesNameList && countriesNameList.includes(locationTextArr[0])) {
                [country] = locationTextArr;
            } else {
                [city] = locationTextArr;
            }
        }

        return {
            locationName: locationItem.text || '',
            city,
            state,
            country,
            latitude,
            longitude,
        };
    };

    const isCountryName = function({ countryName, countries: countriesListTranslated }) {
        const countriesNameListTranslated = _.chain(countriesListTranslated)
            .values()
            .flatten()
            .map('name')
            .map(_.toLower)
            .value();

        const isCountryExistsInTheList = _.includes(countriesNameListTranslated, _.toLower(countryName));

        return isCountryExistsInTheList;
    }

    const extractLocationDataFromLocationText = function({ text, countries }) {
        const locationTextArr = (text || '')
            .split(',')
            .map((item) => item.trim());

        let { city = '', state = '', country = '' } = {};

        if (locationTextArr) {
            if (locationTextArr.length === 3) {
                const [countryCandidate1, countryCandidate2] = locationTextArr;

                const is1CandidateCountry = isCountryName({ countryName: countryCandidate1, countries });
                const is2CandidateCountry = isCountryName({ countryName: countryCandidate2, countries });
                if (is1CandidateCountry) {
                    [country, state, city] = locationTextArr;
                } else if (is2CandidateCountry) {
                    [city, country, state] = locationTextArr;
                } else {
                    [city, state, country] = locationTextArr;
                }
            } else if (locationTextArr.length === 2) {
                const [countryCandidate1, countryCandidate2] = locationTextArr;
                const is1CandidateCountry = isCountryName({ countryName: countryCandidate1, countries });
                const is2CandidateCountry = isCountryName({ countryName: countryCandidate2, countries });

                if (is1CandidateCountry) {
                    [country, city] = locationTextArr;
                } else if (is2CandidateCountry) {
                    [city, country] = locationTextArr;
                } else {
                    [city, state] = locationTextArr;
                }
            } else if (locationTextArr.length === 1) {
                const [countryCandidate1] = locationTextArr;
                const is1CandidateCountry = isCountryName({ countryName: countryCandidate1, countries });
                if (is1CandidateCountry) {
                    [country] = locationTextArr;
                } else {
                    [city] = locationTextArr;
                }
            }
        }

        return {
            city,
            state,
            country,
        };
    };

    const getEnglishCountryCode = function({ countryName, countries: countriesListTranslated }) {
        const countriesListTranslatedEn = _.get(countriesListTranslated, 'en');
        const countriesListTranslatedAll = countriesListTranslated;

        const matchedItem = _.chain(countriesListTranslatedAll)
            .values()
            .flatten()
            .find((c) => _.toLower(c.name) === _.toLower(countryName))
            .value();

        const englishCountryCode = _.chain(countriesListTranslatedEn)
            .find({ id: matchedItem?.id })
            .get('alpha2')
            .value();

        return englishCountryCode;
    };

    return {
        getLocations,
        getLognitudeLatitude,
        getLocationSuggestions,
        getLocationObjectFromDbLocationItem,
        extractLocationDataFromLocationText,
        getEnglishCountryCode,
    };
};

angular
    .module('TALENYA-FE')
    .factory('LocationService', LocationService);
